import { INovaEntity } from './base';

export const COMPANY_VERIFIED_BY = ['internal_user'] as const;

export type CompanyVerifiedBy = (typeof COMPANY_VERIFIED_BY)[number];

export interface ICompany extends INovaEntity {
  name: string;
  scac: string;
  mc: string;
  usdot: string;
  type?: CompanyType;
  legalName?: string | null;
  street?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  zipCode?: string | null;
  phoneNumber?: string | null;
  verifiedBy?: CompanyVerifiedBy | null;
  verifiedAt?: Date | null;
}

export enum CompanyType {
  BROKER = 'type_broker',
  CARRIER = 'type_carrier',
  CARRIER_BROKER = 'type_carrier_broker',
  FORWARDER = 'type_forwarder'
}

/** Tag applied to carrier companies created via ShipperGuide `POST /company/resolve`. */
export const SHIPPERGUIDE_CREATED_COMPANY_TAG = '__shipperguide_created';

/**
 * Public / consumer email domains excluded from ShipperGuide company resolve matching.
 * Corporate domains (e.g. superapi.net) remain eligible.
 */
export const GENERIC_EMAIL_DOMAINS = new Set([
  'aol.com',
  'gmail.com',
  'googlemail.com',
  'gmx.com',
  'gmx.net',
  'hotmail.com',
  'icloud.com',
  'live.com',
  'mac.com',
  'mail.com',
  'me.com',
  'msn.com',
  'outlook.com',
  'proton.me',
  'protonmail.com',
  'yahoo.com',
  'ymail.com'
]);

export function isGenericEmailDomain(domain: string): boolean {
  return GENERIC_EMAIL_DOMAINS.has(domain.trim().toLowerCase());
}
